module.exports = __webpack_public_path__ + "img/296.59c64fa1.svg";